import type { Project } from "../types";

/**
 * Almikia Epic E1 backlog: "a project with compliance_pack_status = pendiente
 * cannot be selected for a new lead or operation". This is the reusable
 * UX-side guard for that rule (the database enforcement is TASK-004).
 *
 * Leads (E2) and operations (E4) do not exist yet: nothing wires this guard
 * into a screen yet. Whichever ticket builds E2 or E4 MUST use
 * `isProjectSellable` and/or `SELLABLE_PROJECTS_FILTER` (or the
 * `SellableProjectInput` built on top of them) instead of allowing a project
 * to be picked directly.
 */

/**
 * Returns true only when the project's compliance pack has been validated
 * and the project is not archived (Almikia Epic E3b-2, "Archive Mazarik":
 * an archived project is hidden for new leads and operations, history kept,
 * never deleted — see `public.is_project_sellable()`). A missing/undefined
 * status is treated as not sellable; a missing `archived` flag is treated
 * as not archived (defaults to `false` in the database).
 */
export function isProjectSellable(
  project:
    | Pick<Project, "compliance_pack_status" | "archived">
    | null
    | undefined,
): boolean {
  return (
    project?.compliance_pack_status === "validado" && project?.archived !== true
  );
}

/**
 * Exact message the DB trigger `enforce_deal_project_sellable()` (TASK-008)
 * raises when a lead's `project_id` is set to a non-'validado' project; the
 * FakeRest parity check must match it verbatim.
 */
export const PROJECT_NOT_SELLABLE_MESSAGE =
  "Solo puedes asignar un proyecto con paquete de cumplimiento validado";

/**
 * Fixed list filter for the `projects` resource, in the ra-data-postgrest
 * `field@operator` syntax so it applies server-side for both the Supabase
 * provider and the FakeRest `supabaseAdapter`.
 */
export const SELLABLE_PROJECTS_FILTER = {
  "compliance_pack_status@eq": "validado",
  "archived@eq": false,
} as const;
